import InvoiceReport from '../components/InvoiceReport';
import type { ConfigData } from '@plone/volto/types';

const applyPaymentHistoryRoutes = (config: ConfigData): ConfigData => {
  config.addonRoutes = [
    ...config.addonRoutes,
    {
      path: '/invoice',
      component: InvoiceReport,
    }
  ];
  return config;
};

export default applyPaymentHistoryRoutes;

